import script from "./MyAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAddress.vue?vue&type=script&setup=true&lang=js"

import "./MyAddress.vue?vue&type=style&index=0&id=676286dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676286dc"]])

export default __exports__